class PopupUrlTrigger {
  constructor() {
    this.selector = 'chiselScripts';

    window.addEventListener('load', () => {
      this.init();
    });
  }

  init() {
    const triggers =
      (window[this.selector] && window[this.selector].popupUrlTriggers) || [];

    if (!triggers.length || typeof window.PUM === 'undefined') {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const match = triggers.find(
      trigger => params.get(trigger.param) === trigger.value,
    );

    if (match) {
      window.PUM.open(match.id);
    }
  }
}

export default new PopupUrlTrigger();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/popup-url-trigger.js